import PropTypes from "prop-types";
import Image from "next/image";
import { colors, DarkTheme, getThemeWithMedia, Text } from "@a0/quantum-web";
import d from "./dictionary";
import * as S from "./styled";
import mediaSizes from "@hub/ui/auth0/shared/mediaSizes";
import { ThemeProvider } from "styled-components";

const ConnectWithA0 = () => {
  return (
    <ThemeProvider theme={getThemeWithMedia(DarkTheme, mediaSizes)}>
      <S.Wrapper>
        <S.CommunityContainer>
          <S.Overline>{d.community.title}</S.Overline>
          <S.CommunityLinksWrapper>
            {d.community.cards.map((card) => (
              <S.CommunityItem key={card.title}>
                <S.CommunityLink href={card.url} target="_blank">
                  <Image
                    src={card.icon}
                    width={40}
                    height={40}
                    alt=""
                    aria-hidden="true"
                  />
                  <S.CommunityLinkContent>
                    <Text
                      type="Paragraph"
                      size="small"
                      styleOverrides={{
                        "font-weight": "500",
                        margin: 0,
                        color: colors.neutral_white,
                        "justify-self": "left",
                      }}
                    >
                      {card.title}
                    </Text>
                    <Text
                      type="Paragraph"
                      size="small"
                      styleOverrides={{
                        margin: 0,
                        color: colors.neutral_n50,
                      }}
                    >
                      {card.description}
                    </Text>
                  </S.CommunityLinkContent>
                </S.CommunityLink>
              </S.CommunityItem>
            ))}
          </S.CommunityLinksWrapper>
        </S.CommunityContainer>
      </S.Wrapper>
    </ThemeProvider>
  );
};

ConnectWithA0.propTypes = {
  upcomingEvents: PropTypes.arrayOf(PropTypes.shape()),
};

export default ConnectWithA0;
